import React, { useEffect, useState } from 'react';
import styles from './workflow.module.scss';
import { KoLoader, KoWorkflow } from 'packages';
import { CUSTOMER_MANAGEMNT_WORKFLOW } from '../customersList/constant';
import { ClientsAPI } from '../customers.service';
export default function CustomerWorkflowType() {
  const [workflows, setWorkflows] = useState(CUSTOMER_MANAGEMNT_WORKFLOW);
  const [loader, setLoader] = useState(true);
  const [templateList, setTemplateList ] = useState([]);

  useEffect(() => {
    getTemplates();
    getWorkflows();
  }, []);
  
  const getWorkflows = async() => {
    setLoader(true);
    try {
      const res = await ClientsAPI.getCustomerWorkflow();
      if (res) {
        setWorkflows(res);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching workflows:', error);
    }
  };
  
  
  const updateWorkflow = async(resetWorkflow) => {
    setLoader(true);
    try {
      const res = await ClientsAPI.updateCustomerWorkflow({workflow:resetWorkflow ? CUSTOMER_MANAGEMNT_WORKFLOW : workflows});
      if (res.status === 200) {
        // await getWorkflows();
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error('Error updating workflow:', error);
    }
  };

  const updateWorkflowData = async(data) => {
    setWorkflows(data?.workflow);
  };

  const getTemplates = (pagination) => {
    setLoader(true);
    ClientsAPI.getTemplates(pagination).then(
      (data) => {
        setTemplateList();
        setTemplateList(data['templates']);
        setLoader(false);
      },
      (err) => {
        setLoader(false);
      }
    );
  };
  

  return (
    <div className={styles.wrapper}>
      {loader && <KoLoader />}
      <KoWorkflow
        customAction={[{
          label:'Save Workflow',
          color:"default", variant:"solid",
          onClick:()=>(updateWorkflow(false))
        }]}
        customColumns={[{
          title: "Notification",
          dataIndex: "templateId",
          key: "templateId",
          editable: true,
          widget:'select',
          options: templateList,
          width: 300
        }]}
        customTemplateList={templateList}
        resetWorkflow={()=>(updateWorkflow(true))} workspace={{status: 0}} noend={true} setTemplateModal={()=>(console.log('resetWorkflow'))} data={{name:'Customer Workflow',  workflow: workflows.length > 0 ? workflows :CUSTOMER_MANAGEMNT_WORKFLOW }} onChange={(data)=>(updateWorkflowData(data))} height={'calc(100vh - 45rem)'} />
    </div>
  );
}
